import { Box, Button, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { TiTick } from 'react-icons/ti'
import ToggleCard from './ToggleCard'

function MarketingPageComponent({data,currency,symbol,cost}) {
    console.log(cost)

  return (
<Box w="25%" textAlign="left" >
        <Box p="4rem 1rem 2rem 2rem" border="1px solid grey">
            <Heading as="h1" size="2xl" mb="4" fontWeight="400">{data.type}</Heading>
            <Text mb="1.5rem" height="100px">{data.des}</Text>
            <ToggleCard cost={cost} symbol={symbol}  currency={currency}/>
            <Text>*<Button variant="link" size="sm"colorScheme="teal" >Overages</Button> apply if contact or email send limit is exceeded.</Text>
            <Button variant="link" colorScheme="grey" borderBottom="dotted" >Learn More</Button>
            <Box mt="1.5rem">
                <Text mb="0.5rem">Everything in Standard, plus:</Text>
            <Box mb="0.5rem" display="flex" alignItems="center" >
                <TiTick fontSize="25px" color='green'/>
                <Button variant="link" color="grey" borderBottom="dotted">Advanced Segmentation</Button> 
            </Box>
            <Box mb="0.5rem" display="flex" alignItems="center" >
                <TiTick fontSize="25px" color='green'/>
                <Button variant="link" color="grey" borderBottom="dotted">Multivariate Testing</Button> 
            </Box>
            <Box  mb="0.5rem" display="flex" alignItems="center" >
                <TiTick fontSize="25px" color='green'/>
                <Text color="grey">Comparitive Reporting</Text> 
            </Box>
            <Box mb="0.5rem" display="flex" alignItems="center" >
                <TiTick fontSize="25px" color='green'/>
                <Text  color="grey">Unlimited Seats & Role-Based Access</Text> 
            </Box>
            <Box mb="0.5rem" display="flex" alignItems="center" >
                <TiTick fontSize="25px" color='green'/>
                <Button variant="link" color="grey" borderBottom="dotted">Phone & Priority Support</Button> 
            </Box>
        </Box>
            <Button mt="2rem" variant="link" color="teal">{data.btn}</Button>
        </Box>
        <Box  p="1rem 1rem 1rem 2rem" border="1px solid grey" >
            <Text>{data.month_des}</Text>
        </Box>
    </Box>
  )
}

export default MarketingPageComponent